export default __webpack_public_path__ + "7465b8c780046e295f9fd1502229eaac.svg";